import React, { useState, useEffect } from "react";
import LocationPicker from "../LocationPicker/LocationPicker";
import DatePicker from "../DatePicker/DatePicker";
import TimePicker from "../TimePicker/TimePicker";
import { findScheduleByDate } from "../DatePicker/DatePickerUtils";
import "./Booking.scss";

const Booking = ({
  locations,
  showLocation = true,
  onBooking,
  value,
  source,
}) => {
  const [location, setLocation] = useState(value?.location);
  const [date, setDate] = useState(null);
  const [slot, setSlot] = useState(null);

  const [schedules, setSchedules] = useState(null);
  const [slots, setSlots] = useState([]);

  const getSchedulesByLocation = (locVal)=> {

    const scedulesByLoc = eventData.find(
      (el) => el.location === locVal.value
    );
    // console.log("locVal: " + JSON.stringify(locVal));
    return scedulesByLoc;
  }


  const onLocationChange = (event, newLocation) => {
    console.log("newLocation: " + JSON.stringify(newLocation));
    setLocation(newLocation);
    clearDeatils();
    if (newLocation) {
      const scedulesByLoc = getSchedulesByLocation(newLocation);
      // console.log("scedulesByLoc: " + JSON.stringify(scedulesByLoc));
      setSchedules(scedulesByLoc?.schedule);
    }
  };

  //clear existing selections
  const clearDeatils = () => {
    setSlot(null);
    setDate(null);
    setSlots(null);
  };

  const getScheduleDetails = (date) => {
    const schedule = findScheduleByDate(date, schedules);
    setSlots(schedule ? schedule.slots : []);
  };

  useEffect(() => {
    const val = { location: location, date: date, slot: slot };
    // console.log(`Location: ${JSON.stringify(location)}, Date: ${JSON.stringify(date)}, Slot: ${JSON.stringify(slot)}`);
    // const localStart = getLocalDate(date);
    // console.log(`start date: ${date}, local start date: ${localStart}`);
    console.log("Updated Value: " + JSON.stringify(val));
    onBooking(val);
  }, [location, date, slot]);

  useEffect(() => {
    console.log(`Initial Value: ${JSON.stringify(value)}`);
    // const location
    if (locations && value?.location) {
      // const defaultLoc = locations?.find((el) => el.value === value?.location.value);
      // setLocation(defaultLoc);
      const scedulesByLoc = getSchedulesByLocation(value?.location);
      setSchedules(scedulesByLoc?.schedule);
    }
  }, []);

  return (
    <div>
      {showLocation && (
        <LocationPicker
          label="Location"
          options={locations}
          value={location}
          onChange={onLocationChange}
        />
      )}
      <div className="container">
        <div className="container__calendar">
          {location && (
            <DatePicker
              schedules={schedules}
              setDate={setDate}
              getScheduleDetails={getScheduleDetails}
              clearDeatils={clearDeatils}
            />
          )}
        </div>
        <div className={`container__time ${date ? "fadeIn" : "fadeOut"}`}>
          <TimePicker slot={slot} setSlot={setSlot} slots={slots} />
        </div>
      </div>
    </div>
  );
};

export default Booking;
